<template>
	<div class="flex w-full flex-col rounded bg-orange-500 p-6">
		<div class="flex-1">
			<h4 class="text-white">All-inclusive car subscription</h4>
			<p class="m-0 p-0 text-base text-white">
				A single weekly payment covers
			</p>
			<TickList
				:items="items"
				:icon-color="`text-white`"
				:class="[`mt-6 text-white`]"
			/>
		</div>
		<div class="flex justify-end">
			<CarbarLink
				:hover="false"
				text-color="text-white"
				underline-color="decoration-white"
				href="/car-subscription"
				text="Learn more"
			/>
		</div>
	</div>
</template>

<script setup>
import TickList from '@/components/lists/TickList.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const items = [
	{
		label: 'Insurance',
	},
	{
		label: 'Rego',
	},
	{
		label: 'Servicing',
	},
	{
		label: 'Price match guarantee',
	},
]
</script>
